import { createClient } from '@/shared/api';
import ADD_ECG_BOOKMARKS from '@/entities/bookmark/api/mutations/addEcgBookmarks';
import { formatEcgBookmarks } from '@/shared/lib/aiUtils';
import type { IEcgBookmark } from '@/shared/model';
import type {
  AddEcgBookmarksMutation,
  AddEcgBookmarksMutationVariables,
} from '@/shared/api/generated/graphql';

export type AddEcgBookmarksResult = {
  isSuccess: boolean;
  message: string;
  ecgBookmarks: IEcgBookmark[];
};

// TODO(ts): typed as the EcgBookmarkInput GraphQL input once its server-side shape is documented
/**
 * Creates new ECG bookmarks on a study. Runs the addEcgBookmarks mutation, throws the server message when it fails, and reshapes the created bookmarks into strip records.
 *
 * @param input - Mutation input describing the bookmarks to add.
 * @returns A promise resolving to the formatted bookmark strip records.
 */
const handleAddEcgBookmarks = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<AddEcgBookmarksMutation, AddEcgBookmarksMutationVariables>({
    mutation: ADD_ECG_BOOKMARKS,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { addEcgBookmarks } = data;
  if (!addEcgBookmarks.isSuccess) {
    throw new Error(addEcgBookmarks.message);
  }
  return formatEcgBookmarks(addEcgBookmarks.ecgBookmarks);
};

export default handleAddEcgBookmarks;
